/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNutritionists } from 'app/entities/nutritionist/nutritionist.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';
import { EntralType } from 'app/shared/model/enumerations/entral-type.model';
import { MealType } from 'app/shared/model/enumerations/meal-type.model';
import { createEntity, getEntity, reset, updateEntity } from './meal.reducer';

export const MealUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nutritionists = useAppSelector(state => state.nutritionist.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const mealEntity = useAppSelector(state => state.meal.entity);
  const loading = useAppSelector(state => state.meal.loading);
  const updating = useAppSelector(state => state.meal.updating);
  const updateSuccess = useAppSelector(state => state.meal.updateSuccess);
  const feedTypeValues = Object.keys(FeedType);
  const entralTypeValues = Object.keys(EntralType);
  const mealTypeValues = Object.keys(MealType);

  const handleClose = () => {
    navigate(`/meal${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNutritionists({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.weight !== undefined && typeof values.weight !== 'number') {
      values.weight = Number(values.weight);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }

    const entity = {
      ...mealEntity,
      ...values,
      createdBy: nutritionists.find(it => it.id.toString() === values.createdBy?.toString()),
      modifiedMeal: nutritionists.find(it => it.id.toString() === values.modifiedMeal?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          feedType: 'ENTERAL',
          entralType: 'GENRAL',
          mealType: 'BEFORE_BREAKFAST',
          ...mealEntity,
          createdBy: mealEntity?.createdBy?.id,
          modifiedMeal: mealEntity?.modifiedMeal?.id,
          hospital: mealEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.meal.home.createOrEditLabel" data-cy="MealCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.meal.home.createOrEditLabel">Create or edit a Meal</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="meal-id"
                  label={translate('tinyMedicRestApp.meal.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.name')}
                id="meal-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  maxLength: { value: 25, message: translate('entity.validation.maxlength', { max: 25 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.tag')}
                id="meal-tag"
                name="tag"
                data-cy="tag"
                type="text"
                validate={{
                  maxLength: { value: 25, message: translate('entity.validation.maxlength', { max: 25 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.description')}
                id="meal-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 225, message: translate('entity.validation.maxlength', { max: 225 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.feedType')}
                id="meal-feedType"
                name="feedType"
                data-cy="feedType"
                type="select"
              >
                {feedTypeValues.map(feedType => (
                  <option value={feedType} key={feedType}>
                    {translate(`tinyMedicRestApp.FeedType.${feedType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.entralType')}
                id="meal-entralType"
                name="entralType"
                data-cy="entralType"
                type="select"
              >
                {entralTypeValues.map(entralType => (
                  <option value={entralType} key={entralType}>
                    {translate(`tinyMedicRestApp.EntralType.${entralType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.mealType')}
                id="meal-mealType"
                name="mealType"
                data-cy="mealType"
                type="select"
              >
                {mealTypeValues.map(mealType => (
                  <option value={mealType} key={mealType}>
                    {translate(`tinyMedicRestApp.MealType.${mealType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.active')}
                id="meal-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.cursor')}
                id="meal-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.lastupdated')}
                id="meal-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.microSec')}
                id="meal-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.timestampentry')}
                id="meal-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.weight')}
                id="meal-weight"
                name="weight"
                data-cy="weight"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.meal.wightUnits')}
                id="meal-wightUnits"
                name="wightUnits"
                data-cy="wightUnits"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField label={translate('tinyMedicRestApp.meal.price')} id="meal-price" name="price" data-cy="price" type="text" />
              <ValidatedField
                id="meal-createdBy"
                name="createdBy"
                data-cy="createdBy"
                label={translate('tinyMedicRestApp.meal.createdBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutritionists
                  ? nutritionists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-modifiedMeal"
                name="modifiedMeal"
                data-cy="modifiedMeal"
                label={translate('tinyMedicRestApp.meal.modifiedMeal')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutritionists
                  ? nutritionists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.meal.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/meal" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MealUpdate;
